import { FC } from "react";

const LoginEmailRow: FC<{ email: string; onChangeEmail: () => void }> = ({ email, onChangeEmail }) => (
  <div className="w-full text-grey-400">
    {email}{" "}
    <span className="link" role="button" onClick={onChangeEmail}>
      Use a different email
    </span>
  </div>
);

export default LoginEmailRow;